import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import {
  getComandas,
  deleteComanda,
  putComanda,
} from "../helpers/rutaComandas";
import Table from "./TableContainer";
import ModalFormComanda from "../components/ModalFormComanda";
import ModalPagosComanda from "../components/ModalPagosComanda";
import { generarPDFComanda } from "../helpers/pdfComandas";
import ModalOrdenCobro from "../components/ModalOrdenCobro";
import { generarPDFOrdenCobroPorNro } from "../helpers/pdfOrdenCobro";
import { getOrdenCobroByNro } from "../helpers/rutaOrdenesCobro";
import ModalVerOrdenCobro from "../components/ModalVerOrdenCobro";
import ModalSaldoCliente from "../components/ModalSaldoCliente";

// >>> NUEVO: OP
import ModalOrdenPago from "../components/ModalOrdenPago";
import { generarPDFOrdenPago } from "../helpers/pdfOrdenPago";

import "../css/tablecomandas.css";

const Styles = styled.div`
  .table-container {
    overflow: auto;
    height: 600px;
    position: relative;
  }

  table {
    border: 1px solid black;
    border-spacing: 0;
    font-size: 13px;
  }

  th,
  td {
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 50;
  }

  th {
    background-color: #0d6efd;
    color: white;
    position: sticky;
    top: 0;
    z-index: 60;
    text-align: center;
    font-size: 12px;
  }

  td {
    background-color: white;
  }

  .pagination {
    padding: 0.5rem;
    background-color: #778899;
    font-size: 15px;
    font-weight: bold;
  }
`;

const ReportHeader = styled.div`
  margin-bottom: 14px;

  .report-head {
    display: flex;
    align-items: center;

    min-height: 78px;

    padding: 14px 18px;

    border: 1px solid #dce5f0;
    border-radius: 14px;

    background:
      linear-gradient(
        120deg,
        #ffffff 0%,
        #f8fafc 65%,
        #f1f5f9 100%
      );

    box-shadow:
      0 3px 14px
      rgba(15, 23, 42, 0.035);
  }

  .report-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #eaf2ff;

    color: #2868c6;

    font-size: 19px;
  }

  .report-text span {
    display: block;

    margin-bottom: 2px;

    color: #5f7fa8;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .report-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .report-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }

  .report-actions {
    display: flex;

    gap: 7px;

    flex-wrap: wrap;

    margin-top: 10px;
    margin-bottom: 10px;
  }

  .report-action {
    min-height: 34px;

    display: inline-flex;
    align-items: center;

    gap: 6px;

    padding: 6px 11px;

    border-radius: 8px;

    background: #ffffff;

    font-size: 10px;
    font-weight: 600;

    cursor: pointer;

    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease;
  }

  .report-action i {
    font-size: 11px;
  }

  .report-action--primary {
    border: 1px solid #6da4ea;

    color: #2468c5;
  }

  .report-action--primary:hover {
    background: #f1f7ff;

    box-shadow:
      0 3px 9px
      rgba(36, 104, 197, 0.1);
  }

  .report-action--secondary {
    border: 1px solid #c9d2dd;

    color: #58687c;
  }

  .report-action--secondary:hover {
    background: #f7f9fb;
  }

  .report-action--success {
    border: 1px solid #73c7a1;

    color: #17885e;
  }

  .report-action--success:hover {
    background: #f0faf6;
  }

  .report-action--dark {
    border: 1px solid #aab4c0;

    color: #36465a;
  }

  .report-action--dark:hover {
    background: #f4f6f8;
  }

  @media (max-width: 768px) {
    .report-head {
      padding: 12px;
    }

    .report-icon {
      width: 42px;
      height: 42px;

      flex-basis: 42px;
    }

    .report-text h3 {
      font-size: 17px;
    }

    .report-actions {
      display: grid;

      grid-template-columns:
        1fr 1fr;
    }

    .report-action {
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    .report-actions {
      grid-template-columns: 1fr;
    }
  }
`;

export default function AppComandaReactTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [comandaSel, setComandaSel] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);

  const [showModalPago, setShowModalPago] = useState(false);
  const [idComandaPago, setIdComandaPago] = useState(null);

  // OC
  const [showModalOC, setShowModalOC] = useState(false);
  const [clienteOC, setClienteOC] = useState(null);
  const [preseleccionOC, setPreseleccionOC] = useState([]);

  const [showVerOC, setShowVerOC] = useState(false);
  const [verOcId, setVerOcId] = useState(null);

  // >>> NUEVO: OP
  const [showModalOP, setShowModalOP] = useState(false);
  const [terceroOP, setTerceroOP] = useState(null);
  const [clienteOP, setClienteOP] = useState(null);
  const [preseleccionOP, setPreseleccionOP] = useState([]);

  const [showSaldoCliente, setShowSaldoCliente] = useState(false);

  const fmtARS = (n) =>
    (Number(n || 0)).toLocaleString("es-AR", {
      style: "currency",
      currency: "ARS",
    });

  const fetchData = useCallback(async () => {
    setLoading(true);
    const resp = await getComandas();
    if (!resp?.ok) {
      console.error(resp?.error || "Error al obtener comandas");
      setData([]);
    } else {
      setData(resp.comandas || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleCloseEdit = () => {
    setShowModalEdit(false);
    fetchData();
  };

  const handleClosePago = () => {
    setShowModalPago(false);
    setIdComandaPago(null);
    fetchData();
  };

  // ========= BORRADO LÓGICO =========
  const borrar = useCallback(
    async (id, codcom) => {
      const ok = window.confirm(
        `¿Está seguro que desea eliminar la comanda${codcom ? ` ${codcom}` : ""}?\n\nEsta acción hará un borrado lógico del registro.`
      );
      if (!ok) return;

      const resp = await deleteComanda(id);

      if (!resp?.ok) {
        alert(resp?.msg || "No se pudo eliminar la comanda.");
        return;
      }

      fetchData();
    },
    [fetchData]
  );

  const editar = useCallback(
    async (id, values) => {
      await putComanda(id, values);
      fetchData();
    },
    [fetchData]
  );

  // ---------- OC ----------
  const openOCFromRow = (row) => {
    const cli = row.original.codclif || row.original.codclic || row.original.codclid;
    if (!cli?._id) return alert("La comanda no tiene cliente asociado.");

    setClienteOC(cli);

    const total = Number(row.original.total || 0);
    const totalPagado = Number(row.original.totalPagado || 0);
    const saldo = total - totalPagado;

    const pre =
      saldo > 0.01
        ? [
            {
              _id: row.original._id,
              codcom: row.original.codcom,
              nroviaje: row.original.nroviaje,
              fecha: row.original.fecha,
              saldo: Number(saldo.toFixed(2)),
              total: Number(total.toFixed(2)),
            },
          ]
        : [];

    setPreseleccionOC(pre);
    setShowModalOC(true);
  };

  const closeOC = (refrescar) => {
    setShowModalOC(false);
    setClienteOC(null);
    setPreseleccionOC([]);
    if (refrescar) fetchData();
  };

  // ---------- OP ----------
  const openOPFromRow = (row) => {
    const tercero = row.original.codtra;
    if (!tercero?._id) {
      return alert("La comanda no tiene 'Transporte' (tercero) asociado.");
    }

    setTerceroOP(tercero);

    const cli = row.original.codclif || row.original.codclic || row.original.codclid;
    setClienteOP(cli?._id ? cli : null);

    const pactado = Number(row.original.pactadoter || 0);
    const pagadoTercero = Number(row.original.pagadoTercero || 0);
    const saldo = pactado - pagadoTercero;

    const pre =
      saldo > 0.01
        ? [
            {
              _id: row.original._id,
              codcom: row.original.codcom,
              nroviaje: row.original.nroviaje,
              fecha: row.original.fecha,
              factura: row.original.factura,
              pactado,
              pagado: pagadoTercero,
              saldo: Number(saldo.toFixed(2)),
            },
          ]
        : [];

    setPreseleccionOP(pre);
    setShowModalOP(true);
  };

const closeOP = (refrescar) => {
  setShowModalOP(false);
  setTerceroOP(null);
  setClienteOP(null);
  setPreseleccionOP([]);
  if (refrescar) fetchData();
};

// ---------- PERMISO ESPECIAL PARA BORRAR COMANDAS ----------
const USUARIOS_HABILITADOS_BORRAR_COMANDAS = [
  "pablonsaya@gmail.com",
  "pablonsaya@hotmail.com",
  "pablosaya@gmail.com",
  "pablosaya@hotmail.com",
];

const normalizarTexto = (v) =>
  String(v || "")
    .toLowerCase()
    .trim();

const buscarEmailEnObjeto = (obj) => {
  if (!obj || typeof obj !== "object") return "";

  const posiblesCampos = [
    "email",
    "correo",
    "mail",
    "username",
    "usuario",
    "user",
  ];

  for (const campo of posiblesCampos) {
    const valor = obj?.[campo];

    if (
      typeof valor === "string" &&
      valor.includes("@") &&
      valor.includes(".")
    ) {
      return normalizarTexto(valor);
    }
  }

  for (const key of Object.keys(obj)) {
    const valor = obj[key];

    if (valor && typeof valor === "object") {
      const encontrado = buscarEmailEnObjeto(valor);
      if (encontrado) return encontrado;
    }

    if (
      typeof valor === "string" &&
      valor.includes("@") &&
      valor.includes(".")
    ) {
      return normalizarTexto(valor);
    }
  }

  return "";
};

const decodeJwtPayload = (token) => {
  try {
    if (!token || token.split(".").length !== 3) return null;

    const base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    while (base64.length % 4) {
      base64 += "=";
    }

    return JSON.parse(atob(base64));
  } catch (error) {
    return null;
  }
};

const getEmailUsuarioActual = () => {
  let email = "";

  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const raw = localStorage.getItem(key);

      if (!raw) continue;

      if (raw.includes("@") && raw.includes(".")) {
        email = normalizarTexto(raw);
      }

      try {
        const obj = JSON.parse(raw);
        const emailObj = buscarEmailEnObjeto(obj);
        if (emailObj) email = emailObj;
      } catch {
        // no era JSON
      }
    }

    const token = localStorage.getItem("token");
    const payload = decodeJwtPayload(token);

    if (payload) {
      const emailToken = buscarEmailEnObjeto(payload);
      if (emailToken) email = emailToken;
    }

    return email;
  } catch (error) {
    console.error("Error leyendo email del usuario:", error);
    return "";
  }
};

const emailUsuarioActual = getEmailUsuarioActual();

const puedeBorrarComandas =
  USUARIOS_HABILITADOS_BORRAR_COMANDAS.includes(emailUsuarioActual);

console.log("EMAIL USUARIO COMANDAS:", emailUsuarioActual);
console.log("PUEDE BORRAR COMANDAS:", puedeBorrarComandas);

const columns = useMemo(
  () => [
      ...(puedeBorrarComandas
      ? [
          {
            id: "editar",
            Header: "Edita",
            accessor: "_id",
            width: 50,
            Cell: ({ row }) => (
              <button
                className="action-btn action-btn--edit"
                title="Editar comanda"
                onClick={() => {
                  setComandaSel(row.original);
                  setShowModalEdit(true);
                }}
              >
                <i
                  className="fa fa-pencil"
                  aria-hidden="true"
                  style={{ color: "#0d6efd" }}
                />
              </button>
            ),
          },
          {
            id: "eliminar",
            Header: "🗑️",
            accessor: "_id",
            width: 50,
            Cell: ({ row }) => (
              <button
                className="action-btn action-btn--delete"
                title="Eliminar comanda"
                onClick={() => borrar(row.original._id, row.original.codcom)}
              >
                <i
                  className="fa fa-trash"
                  aria-hidden="true"
                  style={{ color: "red" }}
                />
              </button>
            ),
          },
        ]
  : []),

      {
        id: "pagar",
        Header: "Paga",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--pay"
            title="Registrar pagos"
            onClick={() => {
              setIdComandaPago(row.original._id);
              setShowModalPago(true);
            }}
          >
            <i className="fa fa-money" aria-hidden="true" />
          </button>
        ),
      },
      {
        id: "pdf",
        Header: "PDF",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--pdf"
            title="Descargar PDF"
            onClick={() => generarPDFComanda(row.original._id)}
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" />
          </button>
        ),
      },

      {
        id: "ordenCobro",
        Header: "OC",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--oc"
            title="Orden de Cobro"
            onClick={() => openOCFromRow(row)}
          >
            <i className="fa fa-credit-card" aria-hidden="true" />
          </button>
        ),
      },

      {
        id: "ordenPago",
        Header: "OP",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--op"
            title="Orden de Pago a tercero"
            onClick={() => openOPFromRow(row)}
          >
            <i className="fa fa-bank" aria-hidden="true" />
          </button>
        ),
      },

      { Header: "Cod", accessor: "codcom", width: 70 },
      { Header: "Nro Viaje", accessor: "nroviaje", width: 90 },
      {
        Header: "Fecha",
        accessor: (r) => (r.fecha ? new Date(r.fecha) : ""),
        id: "fecha",
        width: 120,
        Cell: ({ value }) =>
          value instanceof Date ? value.toLocaleDateString("es-AR") : "-",
      },
  
      { Header: "Chofer", accessor: "codcho.nombre", width: 250 },
      { Header: "Cliente Factura", accessor: "codclif.razonsocial", width: 220 },
      { Header: "Factura", accessor: "factura", width: 200 },
      {
        Header: "Estado",
        accessor: "estado",
        width: 80,
        Cell: ({ value }) => {
            const estadoOriginal = String(value || "").trim();
            const estado = estadoOriginal.toUpperCase();

            const esACobrar =
              estado === "A COBRAR" ||
              estado === "ACOBRAR" ||
              estado.includes("COBRAR");

            const esPagado =
              estado === "PAGADO" ||
              estado === "PAGA" ||
              estado.includes("PAGADO");

            // Si NO es pagado ni a cobrar, lo deja como texto normal
            if (!esPagado && !esACobrar) {
              return (
                <div style={{ textAlign: "center" }}>
                  {estadoOriginal || "-"}
                </div>
              );
            }

            return (
              <div style={{ textAlign: "center" }}>
                <span
                  style={{
                    display: "inline-block",
                    minWidth: 65,
                    padding: "2px 6px",
                    borderRadius: 8,
                    fontWeight: "bold",
                    fontSize: 9,
                    lineHeight: "14px",
                    color: "white",
                    backgroundColor: esPagado ? "#198754" : "#dc3545",
                  }}
                >
                  {estadoOriginal}
                </span>
              </div>
            );
          },
      },
      { Header: "Cliente Carga", accessor: "codclic.razonsocial", width: 220 },
      { Header: "Cliente Descarga", accessor: "codclid.razonsocial", width: 220 },
      { Header: "Transporte", accessor: "codtra.transporte", width: 160 },
      { Header: "Empresa", accessor: "codemp.empresa", width: 160 },
      { Header: "Origen", accessor: "codori.destino", width: 180 },
      { Header: "Destino", accessor: "coddes.destino", width: 180 },
      { Header: "Nro Remito", accessor: "remitos", width: 140 },
      { Header: "Producto", accessor: "codpro.producto", width: 160 },
      { Header: "Camión", accessor: "codcam.camion", width: 160 },
      { Header: "Estado/Situacion", accessor: "codest.estado", width: 120 },

      {
        Header: "Kg Sal",
        accessor: "kgsal",
        id: "kgsal",
        width: 90,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value?.toLocaleString("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.kgsal || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
              {total.toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          );
        },
      },
      {
        Header: "Kg Lle",
        accessor: "kglle",
        id: "kglle",
        width: 90,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value?.toLocaleString("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.kglle || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
              {total.toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          );
        },
      },
      {
        Header: "Dif",
        accessor: "dif",
        id: "dif",
        width: 90,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value?.toLocaleString("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.dif || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
              {total.toLocaleString("es-AR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          );
        },
      },

      {
        Header: "Pactado",
        accessor: "pactado",
        id: "pactado",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? fmtARS(value) : ""}</div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.pactado || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: "Sub Total",
        accessor: "subtotal",
        id: "subtotal",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? fmtARS(value) : ""}</div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.subtotal || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: "IVA",
        accessor: "iva",
        id: "iva",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? fmtARS(value) : ""}</div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.iva || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: "Total",
        accessor: "total",
        id: "total",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? fmtARS(value) : ""}</div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.total || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: () => (
          <span style={{ color: "#dc3545" }}>Pactado Ter</span>
        ),
        accessor: "pactadoter",
        id: "pactadoter",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "#dc3545", fontWeight: 600 }}>
            {fmtARS(Number(value ?? 0))}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce(
            (s, r) => s + (Number(r.values.pactadoter) || 0),
            0
          );
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "#dc3545" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: () => (
          <span style={{ color: "#dc3545" }}>Comisión</span>
        ),
        accessor: "comision",
        id: "comision",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "#dc3545", fontWeight: 600 }}>
            {fmtARS(Number(value ?? 0))}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce(
            (s, r) => s + (Number(r.values.comision) || 0),
            0
          );
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "#dc3545" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: () => (
          <span style={{ color: "#dc3545" }}>Merma</span>
        ),
        accessor: "merma",
        id: "merma",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right", color: "#dc3545", fontWeight: 600 }}>
            {fmtARS(Number(value ?? 0))}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce(
            (s, r) => s + (Number(r.values.merma) || 0),
            0
          );
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "#dc3545" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      { Header: "Km Ori", accessor: "kmsal", width: 90 },
      { Header: "Km Des", accessor: "kmdes", width: 90 },
      { Header: "Observaciones", accessor: "observ", width: 200 },

      {
        Header: "Fecha Carga",
        accessor: (r) => (r.fechaCarga ? new Date(r.fechaCarga) : null),
        id: "fechaCarga",
        width: 110,
        Cell: ({ value }) =>
          value instanceof Date
            ? value.toLocaleDateString("es-AR")
            : "-",
      },

      {
        Header: "Fecha Descarga",
        accessor: (r) => (r.fechaDescarga ? new Date(r.fechaDescarga) : null),
        id: "fechaDescarga",
        width: 120,
        Cell: ({ value }) =>
          value instanceof Date
            ? value.toLocaleDateString("es-AR")
            : "-",
      },

      {
        Header: "Pagado",
        accessor: (r) => r.totalPagado ?? 0,
        id: "totalPagado",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>{value ? fmtARS(value) : ""}</div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.totalPagado || 0), 0);
          return (
            <div style={{ textAlign: "right", fontWeight: "bold", color: "green" }}>
              {fmtARS(total)}
            </div>
          );
        },
      },
      {
        Header: "Saldo",
        accessor: (r) => r.saldoPendiente ?? ((r.total || 0) - (r.totalPagado || 0)),
        id: "saldoPendiente",
        width: 120,
        Cell: ({ value }) => (
          <div
            style={{
              textAlign: "right",
              color: Number(value) < 0 ? "red" : "inherit",
            }}
          >
            {fmtARS(value)}
          </div>
        ),
        Footer: ({ rows }) => {
          const total = rows.reduce((s, r) => s + (r.values.saldoPendiente || 0), 0);
          return (
            <div
              style={{
                textAlign: "right",
                fontWeight: "bold",
                color: total < 0 ? "red" : "blue",
              }}
            >
              {fmtARS(total)}
            </div>
          );
        },
      },
    ],
    [borrar, puedeBorrarComandas]
  );

return (
  <div className="container mt-4">

    <ReportHeader>
      <div className="report-head">
        <div className="report-icon">
          <i
            className="fa fa-list-alt"
            aria-hidden="true"
          />
        </div>

        <div className="report-text">
          <span>
            INFORMES
          </span>

          <h3>
            Listado de Comandas
          </h3>

          <p>
            Consulta, gestión e impresión
            de comandas, órdenes de cobro
            y órdenes de pago.
          </p>
        </div>
      </div>

      <div className="report-actions">

        <button
          type="button"
          className="report-action report-action--primary"
          onClick={() => {
            const id = prompt(
              "Pegá el _id de la Orden de Cobro:"
            );

            if (id) {
              setVerOcId(id);
              setShowVerOC(true);
            }
          }}
        >
          <i className="fa fa-pencil-square-o" />
          Ver/Editar OC por ID
        </button>

        <button
          type="button"
          className="report-action report-action--secondary"
          onClick={async () => {
            const nro = prompt(
              "N° de orden del cliente (ej: 000123):"
            );

            if (!nro) return;

            const res =
              await getOrdenCobroByNro(nro);

            if (res?.ok) {
              setVerOcId(
                res.ordenCobro._id
              );

              setShowVerOC(true);
            } else {
              alert(
                res?.msg ||
                  "No se encontró la Orden de Cobro."
              );
            }
          }}
        >
          <i className="fa fa-search" />
          Ver/Editar OC por N°
        </button>

        <button
          type="button"
          className="report-action report-action--success"
          onClick={async () => {
            const nro = prompt(
              "N° de orden del cliente a imprimir:"
            );

            if (!nro) return;

            await generarPDFOrdenCobroPorNro(
              nro
            );
          }}
        >
          <i className="fa fa-print" />
          Imprimir OC por N°
        </button>

        <button
          type="button"
          className="report-action report-action--dark"
          onClick={async () => {
            const id = prompt(
              "Pegá el _id de la Orden de Pago:"
            );

            if (!id) return;

            await generarPDFOrdenPago(
              id
            );
          }}
        >
          <i className="fa fa-bank" />
          Imprimir OP por ID
        </button>

      </div>
    </ReportHeader>

    <Styles>
      <div className="table-container">
        <Table
          columns={columns}
          data={data}
          loading={loading}
          plugins={[
            useFilters,
            useSortBy,
            usePagination,
          ]}
        />
      </div>
    </Styles>

    {/* TODO LO DEMÁS QUEDA EXACTAMENTE COMO ESTÁ */}
    
      {showModalEdit && (
        <ModalFormComanda
          show={showModalEdit}
          handleClose={handleCloseEdit}
          comanda={comandaSel}
          onSave={editar}
        />
      )}

      <ModalPagosComanda
        show={showModalPago}
        onClose={handleClosePago}
        idComanda={idComandaPago}
      />

      {showModalOC && clienteOC && (
        <ModalOrdenCobro
          show={showModalOC}
          onHide={closeOC}
          cliente={clienteOC}
          comandasPreseleccionadas={preseleccionOC}
        />
      )}

      {showModalOP && terceroOP && (
        <ModalOrdenPago
          show={showModalOP}
          onHide={closeOP}
          tercero={terceroOP}
          cliente={clienteOP}
          comandasPreseleccionadas={preseleccionOP}
        />
      )}

      {showVerOC && (
        <ModalVerOrdenCobro
          show={showVerOC}
          onHide={(refrescar) => {
            setShowVerOC(false);
            setVerOcId(null);
            if (refrescar) fetchData();
          }}
          ocId={verOcId}
        />
      )}

      {showSaldoCliente && (
        <ModalSaldoCliente
          show={showSaldoCliente}
          onHide={() => setShowSaldoCliente(false)}
        />
      )}
    </div>
  );
}